import { render, staticRenderFns } from "./AddKeyword.vue?vue&type=template&id=5c2345fe&"
import script from "./AddKeyword.vue?vue&type=script&lang=js&"
export * from "./AddKeyword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports